var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPianoKeyboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M544 64H32C14.375 64 0 78.375 0 96V416C0 433.625 14.375 448 32 448H544C561.625 448 576 433.625 576 416V96C576 78.375 561.625 64 544 64ZM144 384H64V224H128V304C128 312.875 135.125 320 144 320V384ZM272 384H176V320C184.875 320 192 312.875 192 304V224H256V304C256 312.875 263.125 320 272 320V384ZM400 384H304V320C312.875 320 320 312.875 320 304V224H384V304C384 312.875 391.125 320 400 320V384ZM512 384H432V320C440.875 320 448 312.875 448 304V224H512V384Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPianoKeyboard);
export default __webpack_public_path__ + "static/media/piano-keyboard.1b006cdc334e2964c001cf255ef582c2.svg";
export { ForwardRef as ReactComponent };